import { textStyles } from './defaultTextStyles'

// Re-export everything from defaultTextStyles
export * from './defaultTextStyles'

// Utility function to create a shallow key map (inline to avoid external dependency)
function getShallowObjectKeyMap<T extends object>(
  obj: T,
): { [K in keyof T]: K } {
  return Object.keys(obj).reduce(
    (acc, key) => {
      acc[key as keyof T] = key as keyof T
      return acc
    },
    {} as { [K in keyof T]: K },
  )
}

export type MappedTextStyleKeys = {
  [keyof in keyof typeof textStyles]: keyof typeof textStyles
}

export const textStyleKeys = getShallowObjectKeyMap(
  textStyles,
) as MappedTextStyleKeys
